//authentication actions
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const USER_LOADED_SUCCESS = "USER_LOADED_SUCCESS";
export const USER_LOADED_FAIL = "USER_LOADED_FAIL";
export const AUTHENTICATED_SUCCESS = "AUTHENTICATED_SUCCESS";
export const AUTHENTICATED_FAIL = "AUTHENTICATED_FAIL";
export const PASSWORD_RESET_FAIL = "PASSWORD_RESET_FAIL";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_CONFIRM_FAIL = "PASSWORD_RESET_CONFIRM_FAIL";
export const PASSWORD_RESET_CONFIRM_SUCCESS = "PASSWORD_RESET_CONFIRM_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const ACTIVATION_SUCCESS = "ACTIVATION_SUCCESS";
export const ACTIVATION_FAIL = "ACTIVATION_FAIL";
export const LOGOUT = "LOGOUT";
// get user
export const CURRENT_USER_LOADED_SUCCESS = "CURRENT_USER_LOADED_SUCCESS";
export const CURRENT_USER_LOADED_FAIL = "CURRENT_USER_LOADED_FAIL";
export const TICKETS_LOADED_SUCCESS = "TICKETS_LOADED_SUCCESS";
export const TICKETS_LOADED_FAIL = "TICKETS_LOADED_FAIL";
export const CUSTOMERS_LOADED_SUCCESS = "CUSTOMERS_LOADED_SUCCESS";
export const CUSTOMERS_LOADED_FAIL = "CUSTOMERS_LOADED_FAIL";
export const GET_TRAVEL_ITEM = "GET_TRAVEL_ITEM";
